module.exports = __webpack_public_path__ + "img/set_alpha_2.f2f21311.png";